<template>
    <div>
        <el-row type="flex" align="middle" :gutter="10">
      <el-col :span="16">
        <h2> Referee List </h2>
        <span class="description">Click to each referee to see & edit availability for each referee.</span>
      </el-col>

    </el-row>
    <el-divider></el-divider>
    <el-row>
        <el-col :offset="12" :span="12" class="d-flex flex-row">
            <el-input
                v-model="search"
                placeholder="Search by Referee Name"
                prefix-icon="el-icon-search"
            >
            </el-input>
        </el-col>
    </el-row>
    <el-table :data="board.referees" style="width: 100%" stripe @row-click="goToRow">
        <el-table-column width="auto" property="_id" label="ID"></el-table-column>
        <el-table-column width="auto" property="firstName" label="First Name"></el-table-column>
        <el-table-column width="auto" property="lastName" label="Last Name"></el-table-column>
    </el-table>
    </div>
</template>

<script>

export default {
  data() {
    return {
      board: [],
      search: '',
    };
  },
  mounted() {
    this.$store.commit('loading', true);
    const activeRole = this.$store.getters['user/activeRole'];
    const boardId = activeRole.entity._id;
    this.$http.get(`/assemble/api/v1/admin/appointment-boards/${boardId}`)
      .then((response) => {
        this.board = response.data.data;
        this.$store.commit('loading', false);
      })
      .catch((error) => {
        this.$store.commit('loading', false);
        this.$message.error(error.response.data.message);
      });
  },

  methods: {
    goToRow(row) {
      this.$router.push({
        name: 'my-board-referee-availability-update',
        params: { id: row._id }
      });
    },

  },

};
</script>

<style lang="scss" scoped>

</style>
